
<script>
import { vendorService, orderService, promoCodeService } from "../../services";
import config from "../../config";
import CustomerTab from "./order_tabs/customer-tab";
import { FormWizard, TabContent } from "vue-form-wizard";
import Multiselect from "vue-multiselect";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { required, requiredIf } from "vuelidate/lib/validators";
import { error_message, success_message, get_currency, get_decimal } from "../../Helper/helper";

export default {
  components: {
    DatePicker,
    Multiselect,
    vendorService,
    orderService,
    VueFormWizard: FormWizard,
    TabContent,
    CustomerTab,
    moment,
    promoCodeService,
  },
  data() {
    return {
      decimal: get_decimal(),
      isLoading: false,
      loading: false,
      disabled: false,
      config: config,
      selectedProduct: "",
      products: [],
      items: [],
      variants: [],
      cart: [],
      time_slot: [],
      delivery_charge: [],
      collection_discount_amount: 0,
      collection_discount: 0,
      collection_applicable_amount: 0,
      shipping_add: [],
      shipping_address: [],
      product_id: "",
      product_quanity: "",
      qty: 1,
      item_price: "",
      vat_price: "",
      net_value: 0,
      vat_total: 0,
      vat_percentage: 0,
      item_total: 0,
      refund_price: 0,
      refund_total: 0,
      sub_total: 0,
      sub_total_1: 0,
      sub_total_2: 0,
      sub_price: 0,
      selected_item: null,
      selected_date: "",
      customer_first_name: "",
      customer_last_name: "",
      customer_phone: "",
      customer_address: "",
      customer_email: "",
      customer_bill_address: "",
      currency: get_currency(),
      type: "1",
      order_amount: 0,
      timeslot: "",
      cust_type: "",
      customer_type: "",
      promocode: "",
      promocodeDetail: null,
      promo_loading: false,
      promoApplied: false,
      valid_variants: [],
      vaild_product: [],
      vaild_coupon: "",
      valid_refund: 0,
      valid_item_total: 0,
      valid_sub_total: 0,
      discount_amount: 0,
      total_amount: 0,
      coupon_id: "",
      discount_percentage: 0,
      minimum_order_amount: 0,
      is_flat_discount: 0,
      max_discount_amount: 0,
      is_exist_user: "",
      is_credit: 0,
      credit_amount: 0,
      total_credit: 0,
      item_vat_total : 0,
      b2b_item_total : 0,
      valid_coupon_item_total : 0,
      type_form: {
        selectedProduct: "",
        schedule_date: "",
        order_type: "1",
        parking_place: "1",
        is_elevator: 0,
        // parking_note: "",
        credit: "",
      },
    };
  },
  validations: {
    type_form: {
      schedule_date: {
        required: requiredIf(function (form) {
          return this.order_type == "1";
        }),
      },
    },
  },
  methods: {
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    asyncProduct(query) {
      this.isLoading = true;
      orderService.getProductSearching({ search: query }).then((response) => {
        this.isLoading = false;
        if (response.data.code == 200) {
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
          this.net_value = 0;
          this.vat_total = 0;
          this.item_total = 0;
          this.total_amount = 0;
          this.sub_total = 0;
          this.sub_total_2 = 0;
          this.refund_total = 0;
          this.item_vat_total = 0;
          this.b2b_item_total = 0;
        }
      });
    },
    clearAllProduct() {
      this.selectedProduct = [];
    },
    productSelected(value) {

      var customer_id = "";
      if (this.$refs.customerTab.typeform.customer_id != "") {
        if (this.$refs.customerTab.typeform.customer_id.user_role == "5") {
          this.customer_type = "Business";
          customer_id = this.$refs.customerTab.typeform.customer_id.user_id;
        } else {
          this.customer_type = "Private";
        }
      } else {
        if (this.$refs.customerTab.typeform.user_role == 'Business') {
          this.customer_type = "Business";
        } else {
          this.customer_type = "Private";
        }
      }

      this.product_id = value.id;
      orderService
        .getVariantByProduct({
          customer_id: customer_id,
          product_id: this.product_id,
          customer_type: this.customer_type,
        })
        .then((response) => {
          this.items = response.data.result;
        });
    },
    addVariant(item) {

      var exists = this.variants.some(function (field) {
        return field.id === item.id;
      });
      if (!exists) {
        var price = (item.min_qty <= 1) ? item.price : item.mrp;
        var vatCal = (Number(price * Number(item.vat) / 100));

        this.selected_item = {
          ...item,
          qty: 1,
          item_price: price,
          vat: item.vat,
          vat_price: vatCal,
          vat_percentage: Number(item.vat),
          refund_price: Number(item.refund_price),
        };

        this.variants.push(this.selected_item);

        this.itemTotal(this.variants);
      }
    },
    itemTotal(items) {
      this.item_total = 0;
      this.net_value = 0;
      this.refund_total = 0;
      this.sub_total_2 = 0;
      this.sub_total = 0;
      this.total_amount = 0;
      this.coupon_applicable_amount = 0;
      this.collection_applicable_amount = 0;
      this.item_vat_total = 0;
      this.b2b_item_total = 0;

      for (let i = 0; i < items.length; i++) {
        var variant = items[i];
        var price = (variant.min_qty <= variant.qty) ? variant.price : variant.mrp;
        let itemTotal = Number((variant.qty * Number(price)));
        let refund = Number((Number(variant.refund_price) * variant.qty).toFixed(this.decimal));
        let netTotal = 0;

        if (this.$refs.customerTab.typeform.customer_type == '2') {
          netTotal = Number(((Number(itemTotal) * 100) / (100 + variant.vat)).toFixed(this.decimal));
        } else {
          netTotal = Number(itemTotal.toFixed(this.decimal));
          itemTotal = Number(netTotal + ((netTotal + refund) * variant.vat) / 100).toFixed(this.decimal);
        }
        
        this.item_total = Number((Number(this.item_total) + Number(itemTotal)).toFixed(this.decimal));
        this.net_value = Number((Number(this.net_value) + Number(netTotal)).toFixed(this.decimal));
        this.vat_total = Number(((Number(this.item_total) - Number(this.net_value))).toFixed(this.decimal));
        this.vat_percentage = this.vat_percentage + Number(variant.vat_percentage);
        this.refund_total = this.refund_total + Number(refund);
        this.sub_total_2 = Number(this.item_total);
        this.item_vat_total = Number(this.item_total);
        this.b2b_item_total = Number((Number(this.item_total) + Number(this.refund_total)).toFixed(this.decimal));

        if (this.vaild_product.length > 0) {
          var validProduct = this.vaild_product.filter(function (elem) {
            if (elem == variant.product_id)
              return elem;
          });

          if (validProduct.length > 0) {
            this.valid_item_total = Number(this.item_total.toFixed(this.decimal));
            if(this.$refs.customerTab.typeform.customer_type == '1'){
              this.valid_coupon_item_total = Number(this.valid_coupon_item_total.toFixed(this.decimal));
              this.valid_item_total = this.valid_coupon_item_total;
            }
          }
        }
        if(variant.is_pickup_dis_applicable == 1){
          if (this.$refs.customerTab.typeform.customer_type == '2') {
            this.coupon_applicable_amount = Number(this.item_total.toFixed(this.decimal));
          }else{
            this.coupon_applicable_amount = Number(Number(this.item_total)+Number(this.refund_total)).toFixed(this.decimal);
          }
          
        }

      }
      this.cartCal(0, this.vaild_coupon, this.coupon_applicable_amount);
    },
    couponCal() {
      if (this.vaild_coupon.valid_products.length > 0) {
        if (this.valid_coupon_item_total >= this.vaild_coupon.minimum_order_amount) {
          if (this.vaild_coupon.is_flat_discount == 0) {
            this.discount_amount = Number((Number(this.valid_coupon_item_total * Number(this.vaild_coupon.discount_percentage)) / 100).toFixed(this.decimal));
            if (this.discount_amount > this.vaild_coupon.max_discount_amount) {
              this.discount_amount = Number(this.vaild_coupon.max_discount_amount.toFixed(this.decimal));
            }
          } else {
            this.discount_amount = Number(this.vaild_coupon.max_discount_amount.toFixed(this.decimal));
          }
        }
      }
    },
    cartCal(credit, coupon, pickupApplicableAmount) {
      if (coupon != '') {
        this.couponCal();
      }else{
        this.discount_amount = 0;
      }
      var subAmount = 0;
      var orderTotal = 0;
      var subAmount1 = Number(this.item_total);
      var subAmount2 = subAmount1;
      var deliveryCharge = 0;
      var collectionDiscount = 0;
      pickupApplicableAmount = this.coupon_applicable_amount;
      
      if (this.$refs.customerTab.typeform.customer_id.user_role == 5) {
        subAmount1 = (Number(subAmount1) + Number(this.refund_total));
        subAmount2 = subAmount1;
      }
      this.sub_total_1 = subAmount1;
      
      if (this.discount_amount > 0) {
        subAmount2 = Number(subAmount1) - Number(this.discount_amount);
        if(this.credit_amount > 0){
          subAmount2 = subAmount2 - Number(this.credit_amount);
        }
        pickupApplicableAmount = 0;
      }
     
      if (this.type_form.order_type == 1) { //deliveryAmount is amount
        deliveryCharge = this.delivery_charge;
      } else {
        pickupApplicableAmount = (pickupApplicableAmount == 0) ? subAmount1 : pickupApplicableAmount;
        if (this.discount_amount == 0) {
          collectionDiscount = Number(pickupApplicableAmount) * Number(this.collection_discount)/100;
        }
      }

      if (this.$refs.customerTab.typeform.customer_id.user_role == 5) {
        subAmount2 = subAmount2 + deliveryCharge - collectionDiscount;
      } else {
        subAmount2 = this.refund_total + subAmount2 + deliveryCharge - collectionDiscount;
      }
      
      orderTotal = subAmount2;

      //debit from user credits ---
      if (credit > 0) {
        if (credit > subAmount2) {
          credit = subAmount2;
        }
        orderTotal = subAmount2 - credit;
      }
      this.collection_discount_amount = Number(collectionDiscount.toFixed(this.decimal));
      this.sub_total = subAmount2;
      this.total_amount = orderTotal;

    },
    custQty(sign, variant) {
      let checkQty = 1;

      if (sign == "+") {
        if (checkQty == 0) {
          $("span#plus").css("pointer-events", "none");
          error_message("Product limit over.");
          return false;
        }

        // qty++;
          // if(variant.quantity > variant.qty){
          //   variant.qty++;
          // }
        variant.qty++;
        orderService.checkQuantity({ id: variant.id }).then((response) => {
          this.product_quanity = response.data.result.quantity;

          if (this.product_quanity >= variant.qty) {
            this.itemTotal(this.variants);
            var price = (variant.min_qty <= variant.qty) ? variant.price : variant.mrp;
            variant.item_price = variant.qty * price;
          } else {
            variant.qty--;
            $("span#plus").css("pointer-events", "none");
            error_message("Product limit over.");
            checkQty = 0;
          }
        });
      } else {
        checkQty = 1;
        $("span#plus").css("pointer-events", "visible");
        variant.qty--;
        if (variant.qty != 0) {
          var price = (variant.min_qty <= variant.qty) ? variant.price : variant.mrp;
          variant.item_price = variant.qty * price;
        }
        if (variant.qty == 0) {
          this.delivery_charge = 0;
        }

        this.itemTotal(this.variants);
      }

      if (variant.qty == 0) {
        this.variants.splice(this.variants.indexOf(variant), 1);
        this.itemTotal(this.variants);
        if (this.variants.length == 0) {
          this.net_value = 0;
          this.vat_total = 0;
          this.item_total = 0;
          this.vat_percentage = 0;
          this.refund_total = 0;
          this.sub_total_2 = 0;
          this.total_amount = 0;
          this.item_vat_total = 0;
          this.b2b_item_total = 0;
        }
      }
    },
    getTimeSlot(type) {
    
      this.selected_date = this.moment(this.type_form.schedule_date).format(
        "YYYY-MM-DD"
      );

      if (this.$refs.customerTab.typeform.user_role == "") {
        if (this.$refs.customerTab.typeform.customer_id.user_role == 1) {
          this.cust_type = 2;
        } else {
          this.cust_type = 1; 
        }
      } else {
        if (this.$refs.customerTab.typeform.user_role == "Private") {
          this.cust_type = 2;
        } else {
          this.cust_type = 1;
        }
      }
      this.time_slot = [];
      if (type == 1) {
        orderService.getTimeSlotByDate({
          delivery_date: this.selected_date,
          latitude: this.$refs.customerTab.typeform.latitude,
          longitude: this.$refs.customerTab.typeform.longitude,
          vendor_id: "1",
          order_type: type,
          customer_type: this.cust_type,
        })
          .then((response) => {
            if (response.data.code == 200) {
              this.time_slot = response.data.result.slots;
            } else {
              this.time_slot = [];
            }
          }).catch((error) => {

          })
      }
    },
    Onclick(event) {
      this.timeslot = event.target.value;
    },
    onTypeChange() {
      if(this.type != this.type_form.order_type){
        this.type = this.type_form.order_type;
        this.promoApplied = false;
        this.discount_amount = 0;
        this.vaild_coupon = "";
        this.promocode = "";
      }
      
      if (this.$refs.customerTab.typeform.customer_id == '') {
        this.is_exist_user = 0;
      } else {
        this.is_exist_user = 1;
      }

      this.order_amount = Number(this.item_total);
      if (this.type == 1) {
        this.collection_discount_amount = 0;
      } else {
        this.delivery_charge = 0;
      }

      if (this.$refs.customerTab.typeform.user_role == "") {
        if (this.$refs.customerTab.typeform.customer_id.user_role == 1) {
          this.cust_type = 2;
        } else {
          this.cust_type = 1;
        }
      } else {
        if (this.$refs.customerTab.typeform.user_role == "Private") {
          this.cust_type = 2;
        } else {
          this.cust_type = 1;
        }
      }

      orderService
        .getCharges({
          type: this.type,
          customer_type: this.cust_type,
          amount: this.order_amount,
        })
        .then((response) => {
          if (this.type == 1) {
            this.collection_discount_amount = 0;
            if (response.data.result == "") {
              this.delivery_charge = 0;
            } else {
              //uncomment if client ask for delivery charges
              //this.delivery_charge = response.data.result.delivery_charges;
              this.delivery_charge = 0;
            }
          } else {
            this.delivery_charge = 0;
            if (response.data.result == "") {
              this.collection_discount_amount = 0;
              this.collection_discount = 0;
            } else {
              this.collection_discount = response.data.result.delivery_charges;
              this.collection_discount_amount = 0;
            }
            if (this.order_amount == 0) {
              this.collection_discount_amount = 0;
              this.collection_discount = 0;
            }
          }
          this.itemTotal(this.variants)
        });
    },
    removePromocode() {
      this.promoApplied = false;
      this.promocode = "";
      this.vaild_coupon = "";
      this.coupon_id = "";
      this.cartCal(0, this.vaild_coupon, 0)
    },
    tabChanged(prevIndex, nextIndex) {
      //console.log('nextIndex',nextIndex);
      if (prevIndex == 2) {
        if (this.promoApplied == true) {
          this.removePromocode();
        }
      }

      if (nextIndex == 2) {
        this.onTypeChange();

        this.checkCredit(event);
        orderService.getCredit({ customer_id: this.$refs.customerTab.typeform.customer_id.user_id })
          .then((response) => {
            if (response.data.code == 200) {

              this.total_credit = response.data.result;

            } else {
              error_message("Something went wrong.");
            }
          });

        this.customer_address = this.$refs.customerTab.typeform.address;

        if (this.$refs.customerTab.typeform.shipping_address == "") {
          if (this.$refs.customerTab.typeform.user_role == "Private") {
            this.customer_email = this.$refs.customerTab.typeform.email;
            this.customer_first_name = this.$refs.customerTab.typeform.user_name;
            this.customer_last_name = this.$refs.customerTab.typeform.last_name;
            this.customer_phone = this.$refs.customerTab.typeform.mobile_number;
          } else {
            this.customer_first_name = this.$refs.customerTab.typeform.business_user_name;
            this.customer_last_name = this.$refs.customerTab.typeform.business_last_name;
            this.customer_email = this.$refs.customerTab.typeform.business_email;
            this.customer_phone = this.$refs.customerTab.typeform.business_mobile_number;
          }
        } else {
          this.customer_first_name = this.$refs.customerTab.typeform.shipping_first_name;
          this.customer_last_name = this.$refs.customerTab.typeform.shipping_last_name;
          this.customer_email = this.$refs.customerTab.customer_email;
          this.customer_phone = this.$refs.customerTab.typeform.mobile_number;
        }

        if (this.$refs.customerTab.typeform.is_billing_address == 0) {
          this.customer_bill_address = this.$refs.customerTab.typeform.bill_address;
        }
      }
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    createOrder() {

      this.$v.type_form.$touch();
      if (this.$v.type_form.$invalid) {
        return;
      } else {
        if (!this.variants || this.variants.length == 0) {
          alert("Please add item");
          return false;
        } else if (!this.selected_date || this.selected_date == "") {
          alert("Please select schedule date and time slot");
          return false;
        }
        else {
          this.disabled = true;
          const fd = new FormData();
          var subProducts = this.variants.map((item) => {
            return {
              product_id: item.id,
              quantity: item.qty
            };
          })
          if (this.$refs.customerTab.typeform.user_role == "") {
            fd.append("user_role", this.$refs.customerTab.typeform.user_role);
            fd.append("customer_type", this.customer_type);
            fd.append("address", this.$refs.customerTab.typeform.address);
            fd.append("customer_id", JSON.stringify(this.$refs.customerTab.typeform.customer_id.user_id));
            fd.append("is_billing_address", this.$refs.customerTab.typeform.is_billing_address);
            fd.append("shipping_address_count", this.$refs.customerTab.typeform.shipping_address);

            if (this.$refs.customerTab.typeform.shipping_address == 0 || this.$refs.customerTab.typeform.shipping_address == "undefined") {
              fd.append("city", this.$refs.customerTab.typeform.city);
              fd.append("street", this.$refs.customerTab.typeform.street);
              fd.append("street_no", this.$refs.customerTab.typeform.street_no);
              fd.append("apartment", this.$refs.customerTab.typeform.apartment);
              fd.append("postal_code", this.$refs.customerTab.typeform.postal_code);
              fd.append("address", this.$refs.customerTab.typeform.address);
              fd.append("latitude", this.$refs.customerTab.typeform.latitude);
              fd.append("longitude", this.$refs.customerTab.typeform.longitude);
              fd.append("phone", this.customer_phone);
              fd.append("parking_place", this.$refs.customerTab.typeform.parking_place);
              fd.append("is_elevator", this.$refs.customerTab.typeform.is_elevator);
              fd.append("shipping_first_name", this.customer_first_name);
              fd.append("shipping_last_name", this.customer_last_name);
            }
            if (this.$refs.customerTab.typeform.is_billing_address == 0) {
              fd.append("bill_first_name", this.$refs.customerTab.typeform.bill_first_name);
              fd.append("bill_last_name", this.$refs.customerTab.typeform.bill_last_name);
              fd.append("bill_phone", this.$refs.customerTab.typeform.bill_phone);
              fd.append("bill_city", this.$refs.customerTab.typeform.bill_city);
              fd.append("bill_street", this.$refs.customerTab.typeform.bill_street);
              fd.append("bill_apartment", this.$refs.customerTab.typeform.bill_apartment);
              fd.append("bill_street_no", this.$refs.customerTab.typeform.bill_street_no);
              fd.append("bill_postal_code", this.$refs.customerTab.typeform.bill_postal_code);
              fd.append("bill_address", this.$refs.customerTab.typeform.bill_address);
              fd.append("bill_latitude", this.$refs.customerTab.typeform.bill_latitude);
              fd.append("bill_longitude", this.$refs.customerTab.typeform.bill_longitude);
            }
            fd.append("net_value", this.net_value);
            fd.append("vat_total", this.vat_total);
            fd.append("item_total", this.item_total);
            fd.append("refund_total", this.refund_total);
            fd.append("original_price", this.valid_item_total.toFixed(this.decimal));
            fd.append("sub_total", this.sub_total);
            fd.append("total_amount", this.total_amount);
            fd.append("coupon_code", this.promocode);
            fd.append("delivery_fee", this.delivery_charge);
            fd.append("coupon_id", this.coupon_id);
            fd.append("discount_percentage", this.discount_percentage);
            fd.append("minimum_order_amount", this.minimum_order_amount);
            fd.append("is_flat_discount", this.is_flat_discount);
            fd.append("max_discount_amount", this.max_discount_amount);
            fd.append("discount_amount", this.discount_amount.toFixed(this.decimal));
            fd.append("collection_discount", this.collection_discount);
            fd.append("collection_discount_amount", this.collection_discount_amount);
            fd.append("delivery_type", this.type_form.order_type);
            fd.append("delivery_date", this.selected_date);
            fd.append("credit_amount", this.credit_amount);
            fd.append("suggestion", this.$refs.customerTab.typeform.notes);
            fd.append("item_vat_total", this.item_vat_total);
            if (this.type_form.order_type == 1) {
              fd.append("timeslot", this.timeslot);
            } else {
              this.timeslot = "10:00:00 - 22:00:00";
              fd.append("timeslot", this.timeslot);
            }
            fd.append("sub_product", JSON.stringify(subProducts));
          } else {

            fd.append("user_role", this.$refs.customerTab.typeform.user_role);
            fd.append("customer_type", this.customer_type);
            fd.append("user_name", this.$refs.customerTab.typeform.user_name);
            fd.append("last_name", this.$refs.customerTab.typeform.last_name);
            fd.append("email", this.$refs.customerTab.typeform.email);
            fd.append("mobile_number", this.$refs.customerTab.typeform.mobile_number);
            fd.append("city", this.$refs.customerTab.typeform.city);
            fd.append("street", this.$refs.customerTab.typeform.street);
            fd.append("street_no", this.$refs.customerTab.typeform.street_no);
            fd.append("apartment", this.$refs.customerTab.typeform.apartment);
            fd.append("postal_code", this.$refs.customerTab.typeform.postal_code);
            fd.append("address", this.$refs.customerTab.typeform.address);
            fd.append("latitude", this.$refs.customerTab.typeform.latitude);
            fd.append("longitude", this.$refs.customerTab.typeform.longitude);
            fd.append("shipping_first_name", this.customer_first_name);
            fd.append("shipping_last_name", this.customer_last_name);
            fd.append("name", this.$refs.customerTab.typeform.name);
            fd.append("hrb", this.$refs.customerTab.typeform.hrb);
            fd.append("vat", this.$refs.customerTab.typeform.vat);
            fd.append("person_first_name", this.$refs.customerTab.typeform.person_first_name);
            fd.append("person_last_name", this.$refs.customerTab.typeform.person_last_name);
            fd.append("person_phone", this.$refs.customerTab.typeform.person_phone);
            fd.append("person_email", this.$refs.customerTab.typeform.person_email);
            fd.append("is_contact_person", this.$refs.customerTab.typeform.is_contact_person);
            fd.append("business_user_name", this.$refs.customerTab.typeform.business_user_name);
            fd.append("business_last_name", this.$refs.customerTab.typeform.business_last_name);
            fd.append("business_email", this.$refs.customerTab.typeform.business_email);
            fd.append("business_mobile_number", this.$refs.customerTab.typeform.business_mobile_number);
            fd.append("notes", this.$refs.customerTab.typeform.notes);
            fd.append("parking_place", this.$refs.customerTab.typeform.parking_place);
            fd.append("is_elevator", this.$refs.customerTab.typeform.is_elevator);
            fd.append("customer_id", JSON.stringify(this.$refs.customerTab.typeform.customer_id));
            fd.append("is_new_user", this.$refs.customerTab.typeform.is_new_user);
            fd.append("is_billing_address", this.$refs.customerTab.typeform.is_billing_address);
            fd.append("bill_first_name", this.$refs.customerTab.typeform.bill_first_name);
            fd.append("bill_last_name", this.$refs.customerTab.typeform.bill_last_name);
            fd.append("bill_phone", this.$refs.customerTab.typeform.bill_phone);
            fd.append("bill_city", this.$refs.customerTab.typeform.bill_city);
            fd.append("bill_street", this.$refs.customerTab.typeform.bill_street);
            fd.append("bill_apartment", this.$refs.customerTab.typeform.bill_apartment);
            fd.append("bill_street_no", this.$refs.customerTab.typeform.bill_street_no);
            fd.append("bill_postal_code", this.$refs.customerTab.typeform.bill_postal_code);
            fd.append("bill_address", this.$refs.customerTab.typeform.bill_address);
            fd.append("bill_latitude", this.$refs.customerTab.typeform.bill_latitude);
            fd.append("bill_longitude", this.$refs.customerTab.typeform.bill_longitude);
            fd.append("net_value", this.net_value);
            fd.append("vat_total", this.vat_total);
            fd.append("item_total", this.item_total);
            fd.append("refund_total", this.refund_total);
            fd.append("original_price", this.valid_item_total.toFixed(this.decimal));
            fd.append("sub_total", this.sub_total);
            fd.append("total_amount", this.total_amount);
            fd.append("coupon_code", this.promocode);
            fd.append("delivery_fee", this.delivery_charge);
            fd.append("coupon_id", this.coupon_id);
            fd.append("discount_percentage", this.discount_percentage);
            fd.append("minimum_order_amount", this.minimum_order_amount);
            fd.append("is_flat_discount", this.is_flat_discount);
            fd.append("max_discount_amount", this.max_discount_amount);
            fd.append("discount_amount", this.discount_amount);
            fd.append("collection_discount", this.collection_discount);
            fd.append("collection_discount_amount", this.collection_discount_amount);
            fd.append("delivery_type", this.type_form.order_type);
            fd.append("delivery_date", this.selected_date);
            fd.append("credit_amount", this.credit_amount);
            fd.append("sub_product", JSON.stringify(subProducts));
            fd.append("item_vat_total", this.item_vat_total);
            fd.append("suggestion", this.$refs.customerTab.typeform.notes);
            
            if (this.type_form.order_type == 1) {
              fd.append("timeslot", this.timeslot);
            } else {
              this.timeslot = "10:00:00 - 22:00:00";
              fd.append("timeslot", this.timeslot);
            }
          }
          orderService.addOrderCustomer(fd).then((response) => {
            this.disable = false;
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.$router.push({ name: "orders-list" });
            } else {
              error_message(response.data.message);
              this.disabled = false;
            }
          });
        }
      }
    },
    onClickChild(value) {
      this.variants = [];
      this.products = [];
      this.net_value = 0;
      this.vat_total = 0;
      this.item_total = 0;
      this.sub_total = 0;
      this.total_amount = 0;
      this.refund_total = 0;
      this.items = [];
      this.time_slot = [];
      this.delivery_charge = [];
      this.collection_discount_amount = 0;
      this.collection_discount = 0;
      this.shipping_add = [];
      this.shipping_address = [];
      this.product_id = "";
      this.product_quanity = "";
      this.qty = 1;
      this.item_price = "";
      this.vat_price = "";
      this.refund_price = 0;
      this.sub_price = 0;
      this.selected_item = null;
      this.selected_date = "";
      this.customer_first_name = "";
      this.customer_last_name = "";
      this.customer_phone = "";
      this.customer_address = "";
      this.customer_email = "";
      this.customer_bill_address = "";
      this.type = "1";
      this.order_amount = 0;
      this.timeslot = "";
      this.cust_type = "";
      this.type_form = {
        selectedProduct: "",
        schedule_date: "",
        order_type: "1",
        parking_place: "1",
        is_elevator: 0,
        parking_note: "",
      };
    },
    onUserType(value) {
      this.variants = [];
      this.products = [];
      this.net_value = 0;
      this.vat_total = 0;
      this.item_total = 0;
      this.sub_total = 0;
      this.total_amount = 0;
      this.refund_total = 0;
      this.items = [];
      this.time_slot = [];
      this.delivery_charge = [];
      this.delivery_charge = 0;
      this.collection_discount_amount = [];
      this.collection_discount = 0;
      this.shipping_add = [];
      this.shipping_address = [];
      this.product_id = "";
      this.product_quanity = "";
      this.qty = 1;
      this.item_price = "";
      this.vat_price = "";
      this.refund_price = 0;
      this.sub_price = 0;
      this.selected_item = null;
      this.selected_date = "";
      this.customer_first_name = "";
      this.customer_last_name = "";
      this.customer_phone = "";
      this.customer_address = "";
      this.customer_email = "";
      this.customer_bill_address = "";
      this.type = "1";
      this.order_amount = 0;
      this.timeslot = "";
      this.cust_type = "";
      (this.type_form = {
        selectedProduct: "",
        schedule_date: "",
        order_type: "1",
        parking_place: "1",
        is_elevator: 0,
        // parking_note: "",
      }),
        (this.$refs.customerTab.shipping_data = []);
    },
    applyPromoCode() {
      if (this.promoApplied) {
        this.removePromocode()
        return false;
      }
      else if (!this.variants || this.variants.length == 0) {
        alert("Please add item");
        return false;
      } else {
        this.promo_loading = true;
        promoCodeService
          .applyPromoCode({
            customer_type: this.cust_type,
            sub_product: this.variants,
            coupon_code: this.promocode,
            amount:  this.cust_type == 1 ? Number(this.b2b_item_total) : Number(this.item_total),
            type: this.type,
            customer: JSON.stringify(this.$refs.customerTab.typeform.customer_id),
          })
          .then((response) => {
            this.promo_loading = false;
            if (response.data.code === 101) {
              error_message(response.data.message);
            }
            if (response.data.code === 200) {
              this.vaild_coupon = response.data.result;
              this.valid_variants = this.variants;
              this.coupon_id = response.data.result.coupon_id;
              this.discount_percentage = response.data.result.discount_percentage;
              this.minimum_order_amount = response.data.result.minimum_order_amount;
              this.is_flat_discount = response.data.result.is_flat_discount;
              this.max_discount_amount = response.data.result.max_discount_amount;
              this.vaild_product = response.data.result.valid_products;
              this.valid_coupon_item_total = response.data.result.vaild_item_total;

              this.itemTotal(this.variants)

              success_message(response.data.message);
              this.promoApplied = true;
              return false;
            }
          });
      }
    },

    checkCredit(event) {

      if (event.target.checked == true) {

        this.is_credit = 1;
        orderService.getCredit({ customer_id: this.$refs.customerTab.typeform.customer_id.user_id })
          .then((response) => {
            if (response.data.code == 200) {

              this.total_credit = response.data.result;


              if (this.total_credit > 0) {
                if (this.total_credit >= this.sub_total) {

                  this.credit_amount = this.sub_total;

                  this.total_amount = Number(Number(this.sub_total) - Number(this.credit_amount));

                } else {

                  this.credit_amount = this.total_credit;
                  this.total_amount = Number(Number(this.sub_total) - Number(this.credit_amount));
                }
              } else {
                this.total_amount = this.sub_total;
                error_message("Sorry, You do not have credits.");
              }
            } else {
              error_message("Something went wrong.");
            }
          });

      } else {
        if (this.credit_amount > 0) {
          //this.total_amount = Number(Number(this.total_amount) + Number(this.credit_amount));
          this.total_amount = Number(Number(this.total_amount));
          this.credit_amount = 0;
        }
        this.is_credit = 0;
      }
    },
    validateProducts(){
      if(this.type_form.selectedProduct.length == 0){
        return false;
      }else{
        return true;
      }
      
    }
  },
  
};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <vue-form-wizard shape="tab" color="#556ee6" @on-change="tabChanged">
        <tab-content icon="mdi mdi-account-circle" title="Customer Details"
          :before-change="() => validateStep('customerTab')">
          <customer-tab ref="customerTab" @clicked="onClickChild" @changed="onUserType" @getTimeSlot="getTimeSlot">
          </customer-tab>
        </tab-content>

        <tab-content icon="mdi mdi-food" :title="trans.get('__JSON__.Product')" :before-change="() => validateProducts('products')">
          <div class="col-12">
            <div class="row">
              <div class="col-md-6">
                <div class="drag-container">
                  <div class="row drag-list menu-left-main">
                    <div class="drag-column mulit-sel">
                      <span class="font-size-15 font-weight-medium">{{
                          trans.get("__JSON__.Products")
                      }}</span>
                      <div class="position-relative">
                        <multiselect v-model="type_form.selectedProduct" id="item_name" label="item_name"
                          track-by="item_name" :placeholder="trans.get('__JSON__.Product Search')"
                          open-direction="bottom" :options="products" :multiple="false" :searchable="true"
                          :loading="isLoading" @search-change="asyncProduct" @select="productSelected">
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                              <span>{{ option.item_name }})</span>
                              <span class="custom__remove" @click="remove(option)">❌</span>
                            </span>
                          </template>
                          <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="selectedProduct.length"
                              @mousedown.prevent.stop="clearAll(props.search)"></div>
                          </template>
                          <span slot="noResult">{{ trans.get("__JSON__.No Product Found") }}.</span>
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="drag-column">
                    <b-list-group>
                      <template v-if="items && items.length != 0 && !loading">
                        <template v-for="item in items || []">
                          <b-list-group-item :key="item.id">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex">
                                <div>
                                  <div v-if="item.item_type == '0'" class="position-static veg">
                                    <span></span>
                                  </div>
                                  <div v-if="item.item_type == '1'" class="position-static non-veg">
                                    <span></span>
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex">
                                    <span class="
                                        font-size-13 font-weight-medium
                                        pl-1
                                      " :title="item.sub_product_name">{{
                                          item.sub_product_name
                                          | truncate(35, "...")
                                      }}
                                      ({{ item.material }})</span>
                                  </div>
                                  <span class="font-size-11 pl-1"
                                    :class="[(item.is_discount == 1 && item.is_b2b_price == 0) ? 'price-red' : '', (item.is_b2b_price == 1 && item.is_discount == 0) ? 'price-blue' : '', (item.is_discount == 0 && item.is_b2b_price == 0 ? 'text-secondary' : '')]">price
                                    :
                                    {{
                                        parseFloat(item.price).toFixed(decimal)
                                    }}<span v-html="currency"></span></span>
                                  <span :class="((item.is_discount == 1 && item.is_b2b_price == 0) ? 'text-decoration-line-through ' : '')+'font-size-11 pl-1 text-secondary'">mrp :
                                    {{
                                        parseFloat(item.mrp).toFixed(decimal)
                                    }}<span v-html="currency"></span></span>
                                  <span class="font-size-11 pl-1 text-secondary"
                                    v-if="item.is_b2b_price == 1 && item.is_discount == 0">minimum quntity :
                                    {{
                                        item.min_qty
                                    }}</span>
                                  <span class="font-size-11 pl-1 text-secondary">refund price :

                                    {{
                                        parseFloat(item.refund_price).toFixed(
                                          decimal
                                        )
                                    }}<span v-html="currency"></span></span>
                                </div>
                              </div>
                              <div>
                                <div class="cst-swtch-set">
                                  <div class="list-available d-flex" v-if="item.quantity > 0">
                                    <button class="btn btn-primary" id="add_variant" @click="addVariant(item)">
                                      {{ trans.get("__JSON__.Add") }}
                                    </button>
                                  </div>
                                  <div class="list-available d-flex" v-else>
                                    <span class="text-danger">{{
                                        trans.get("__JSON__.Sold out")
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-list-group-item>
                        </template>
                      </template>
                      <div v-else-if="loading" class="text-center text-danger my-2 pt-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                      </div>
                      <b-list-group-item v-else key="abc" class="
                          align-items-center
                          d-flex
                          justify-content-between
                        ">
                        {{ trans.get("__JSON__.No sub product found") }}
                      </b-list-group-item>
                    </b-list-group>
                    <div class="row mt-2" v-if="!loading">
                      <div class="col">
                        <div class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-right
                          " v-if="items && items.data">
                          <ul class="pagination pagination-rounded mb-0">
                            <pagination :data="items" :limit="limit" @pagination-change-page="listitembyid">
                            </pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="drag-column">
                  <b-list-group>
                    <template v-for="variant in variants || []">
                      <b-list-group-item :key="variant.id">
                        <div class="row justify-content-between">
                          <div class="col-md-5">
                            <div class="d-flex">
                              <span class="font-size-13 font-weight-medium pl-1" :title="variant.sub_product_name">{{
                                  variant.sub_product_name | truncate(35, "...")
                              }}
                                ({{ variant.material }})</span>
                            </div>
                            <span class="font-size-11 pl-1 text-secondary">price :
                              {{
                                  parseFloat(variant.price).toFixed(decimal)
                              }} <span v-html="currency"></span></span>
                            <span class="font-size-11 pl-1 text-secondary">mrp :
                              {{
                                  parseFloat(variant.mrp).toFixed(decimal)
                              }}<span v-html="currency"></span></span>
                          </div>
                          <div class="col-md-3">
                            <div class="list-available d-flex item-new-add">
                              <span class="
                                  minus
                                  d-flex
                                  justify-content-center
                                  align-items-center
                                " @click="custQty('-', variant)">-</span>
                              <span class="qty-item">{{ variant.qty }}</span>
                              <span class="
                                  d-flex
                                  justify-content-center
                                  align-items-center
                                " id="plus" @click="custQty('+', variant)">+</span>
                            </div>
                          </div>
                          <div class="col-md-4 text-right">
                            <span class="font-size-11 pl-1 text-secondary">price :
                              {{
                                  parseFloat(variant.item_price).toFixed(decimal)
                              }}<span v-html="currency"></span></span>
                          </div>
                        </div>
                      </b-list-group-item>
                    </template>
                    <div>
                      <span class="font-size-11 pl-1 text-secondary">Net Value :
                        {{ parseFloat(net_value).toFixed(decimal) }}<span v-html="currency"></span></span>
                      <span class="font-size-11 pl-1 text-secondary">Vat Total :
                        {{ parseFloat(vat_total).toFixed(decimal) }}<span v-html="currency"></span></span>
                      <span class="font-size-11 pl-1 text-secondary">total :
                        {{ parseFloat(item_total).toFixed(decimal) }}<span v-html="currency"></span></span>
                    </div>
                  </b-list-group>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>

        <tab-content icon="mdi mdi-checkbox-marked-circle-outline" :title="trans.get('__JSON__.Order Summary')"
          :change="() => onTypeChange()">
          <div class="row">
            <div class="col-sm-4">
              <div>
                <div class="mt-2">
                  <label for="future_delivery_date">{{
                      trans.get("__JSON__.Order Type")
                  }}</label>
                  <select name="order_type" class="custom-select" id="order_type" v-model="type_form.order_type"
                    @change="onTypeChange()">
                    <option value="">
                      {{ trans.get("__JSON__.Select Order Type") }}
                    </option>
                    <option value="1" selected>Delivery</option>
                    <option value="0">Pickup</option>
                  </select>
                </div>
                <div class="mt-2">
                  <label for="future_delivery_date">{{
                      trans.get("__JSON__.Schedule Time")
                  }}</label>
                  <date-picker :clearable="false" v-model="type_form.schedule_date" format="YYYY-MM-DD" type="date"
                    class="date-time" :placeholder="trans.get('__JSON__.Select Schedule Time')" valueType="date"
                    @change="getTimeSlot(type)" :disabled-date="disabledBeforeTodayAndAfterAWeek"></date-picker>
                </div>
              </div>
              <div class="InputGroup mt-2" style="padding-left: 20px;">
                <div v-if="time_slot.length > 0 && type == 1">
                  <div v-for="slot in time_slot" :key="slot.id">
                    <div v-if="slot.is_available == 1">
                      <input class="form-check-input" type="radio" name="time" id="time" @change="Onclick($event)"
                        v-bind:value="slot.from_time + '-' + slot.to_time" />
                      <label class="form-check-label" for="time">{{ slot.from_time }} - {{ slot.to_time }}</label>
                    </div>
                    <div v-else>
                      <!-- <input class="form-check-input" type="radio" name="time" id="time" v-bind:value="slot.from_time +'-'+ slot.to_time"/> -->
                      <label class="form-check-label" for="time">{{ slot.from_time }} - {{ slot.to_time }} (Not
                        Available)</label>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span v-if="type == 1">{{ trans.get("__JSON__.Timeslot not found") }}.</span>
                </div>
              </div>
              <div class="mt-2" v-if="is_exist_user == 1 && total_credit > 0">
                <b-form-group id="input-group-2" label-for="Credit">
                  <div class="row">
                    <div class="col-sm-12">
                      <input type="checkbox" v-model="is_credit" true-value="1" false-value="0"
                        v-on:input="checkCredit($event)">
                      <label for="checkbox">{{ trans.get('__JSON__.Want to use credit') }}</label>
                      {{ parseFloat(total_credit).toFixed(decimal) }}<span v-html="currency"></span>
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div class="col-sm-4">
              <b-list-group>
                <b-list-group-item>
                  <span class="font-size-14 font-weight-bold">{{ trans.get("__JSON__.Customer Name") }}:
                  </span>
                  {{ customer_first_name }} {{ customer_last_name }}
                </b-list-group-item>
                <b-list-group-item>
                  <span class="font-size-14 font-weight-bold">{{ trans.get("__JSON__.Email") }}:
                  </span>
                  {{ customer_email }}
                </b-list-group-item>
                <b-list-group-item>
                  <span class="font-size-14 font-weight-bold">{{ trans.get("__JSON__.Phone") }}:
                  </span>
                  {{ (customer_phone != "") ? customer_phone : '-' }}
                </b-list-group-item>
                <b-list-group-item>
                  <span class="font-size-14 font-weight-bold">{{ trans.get("__JSON__.Address") }}:
                  </span>
                  {{ customer_address || "" }}
                </b-list-group-item>
              </b-list-group>
            </div>

            <div class="col-sm-4">
              <div>
                <label for="Promo Code">{{
                    trans.get("__JSON__.Promo Code")
                }}</label>
                <b-input-group prepend="Enter Code">
                  <b-form-input ref="promocode" name="promocode" v-model="promocode" :disabled="promoApplied"
                    @keyup.enter="applyPromoCode"></b-form-input>
                  <b-input-group-append>
                    <b-button :variant="
                      promoApplied ? 'outline-danger' : 'outline-success'
                    " @click="applyPromoCode" :disabled="promo_loading">{{ promoApplied ? "Remove" : "Apply" }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <table style="width:100%;">
                <tr>
                  <td>Net Value :</td>
                  <td class="float-right">{{ parseFloat(net_value).toFixed(decimal) }}<span v-html="currency"></span>
                  </td>
                </tr>
                <tr style="border-bottom:1px solid #eee;">
                  <td>Tax :</td>
                  <td class="float-right">{{ parseFloat(vat_total).toFixed(decimal) }}<span v-html="currency"></span>
                  </td>
                </tr>
                <tr v-if="this.customer_type == 'Business'">
                  <td>Refund Total :</td>
                  <td class="float-right">{{ parseFloat(refund_total).toFixed(decimal) }}<span v-html="currency"></span>
                  </td>
                </tr>
                <tr style="border-bottom:1px solid #eee;">
                  <td>Sub Total 1 :</td>
                  <td class="float-right">{{ parseFloat(sub_total_1).toFixed(decimal) }}<span v-html="currency"></span>
                  </td>
                </tr>
                <tr v-if="type_form.order_type == '0'">
                  <td>Collection Discount ({{ collection_discount }}%):</td>
                  <td class="float-right"> <span v-if="collection_discount_amount > 0">-</span> 
                  {{ parseFloat(collection_discount_amount).toFixed(decimal) }}<span v-html="currency"></span></td>
                </tr>
                <tr style="border-bottom:1px solid #eee;">
                  <td>Coupon Discount :</td>
                  <td class="float-right"> <span v-if="discount_amount > 0">-</span> {{
                      parseFloat(discount_amount).toFixed(decimal)
                  }}<span v-html="currency"></span></td>
                </tr>
                <tr v-if="this.customer_type != 'Business'">
                  <td>Refund Total :</td>
                  <td class="float-right">{{ parseFloat(refund_total).toFixed(decimal) }}<span v-html="currency"></span>
                  </td>
                </tr>
                <tr v-if="type_form.order_type == '1'">
                  <td>Delivery Fees :</td>
                  <td class="float-right">{{ parseFloat(delivery_charge).toFixed(decimal) }}<span
                      v-html="currency"></span></td>
                </tr>
                <tr>
                  <td>Credit:</td>
                  <td class="float-right"><span v-if="credit_amount > 0">-</span> {{
                      parseFloat(credit_amount).toFixed(decimal)
                  }}<span v-html="currency"></span></td>
                </tr>
                <tr>
                  <td><strong>Total :</strong></td>
                  <td class="float-right"><strong>{{ parseFloat(total_amount).toFixed(decimal) }}</strong><span
                      v-html="currency"></span></td>
                </tr>
              </table>
            </div>
          </div>
        </tab-content>

        <div slot="finish"></div>
        <button slot="finish" class="btn btn-primary mr-1 mt-3" id="place_order" :disabled="disabled"
          @click="createOrder">
          {{ trans.get("__JSON__.Place Order") }}
        </button>
      </vue-form-wizard>
    </div>
  </div>
</template>
  <style>
  .price-red {
    color: red;
  }
  
  .price-blue {
    color: blue;
  }
  .text-decoration-line-through{
    text-decoration: line-through;
  }
  </style>